"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _AccuracyLevels = _interopRequireDefault(require("./AccuracyLevels"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeSync = /*#__PURE__*/function () {
  function TimeSync(socket, accuracy) {
    var _AccuracyLevels$LOW$A;

    _classCallCheck(this, TimeSync);

    _defineProperty(this, "intervalHandle", null);

    _defineProperty(this, "intervalTime", 500);

    _defineProperty(this, "timeSyncArray", []);

    _defineProperty(this, "lastSyncTime", null);

    _defineProperty(this, "timeSyncCorrection", Infinity);

    _defineProperty(this, "timeSyncRoundTrip", Infinity);

    this.calculateCorrection = this.calculateCorrection.bind(this);
    this.requestTime = this.requestTime.bind(this);
    this.getOffset = this.getOffset.bind(this);
    this.getRoundTrip = this.getRoundTrip.bind(this);
    this.socket = socket;
    var count = (_AccuracyLevels$LOW$A = {}, _defineProperty(_AccuracyLevels$LOW$A, _AccuracyLevels["default"].LOW, {
      count: 2
    }), _defineProperty(_AccuracyLevels$LOW$A, _AccuracyLevels["default"].MEDIUM, {
      count: 10
    }), _defineProperty(_AccuracyLevels$LOW$A, _AccuracyLevels["default"].HIGH, {
      count: 20
    }), _AccuracyLevels$LOW$A)[accuracy].count;
    this.intervalCount = count;
  }

  _createClass(TimeSync, [{
    key: "getOffset",
    value: function getOffset() {
      if (this.lastSyncTime) {
        return this.timeSyncCorrection;
      }

      return undefined;
    }
  }, {
    key: "getRoundTrip",
    value: function getRoundTrip() {
      if (this.lastSyncTime) {
        return this.timeSyncRoundTrip;
      }

      return undefined;
    }
  }, {
    key: "requestTime",
    value: function () {
      var _requestTime = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.timeSyncArray = [];
                            clearInterval(_this.intervalHandle);
                            _this.intervalHandle = setInterval(function () {
                              if (_this.timeSyncArray.length < _this.intervalCount) {
                                _this.socket.emit('getTime', {
                                  clientTransmitTime: +_moment["default"].utc()
                                }, function (_ref2) {
                                  var clientTransmitTime = _ref2.clientTransmitTime,
                                      errMessage = _ref2.errMessage,
                                      serverTransmitTime = _ref2.serverTransmitTime,
                                      status = _ref2.status;

                                  if (status === 'OK') {
                                    var receiveTime = +_moment["default"].utc();
                                    var roundTrip = receiveTime - clientTransmitTime;
                                    var offset = serverTransmitTime - (clientTransmitTime + roundTrip / 2);

                                    _this.timeSyncArray.push({
                                      offset: offset,
                                      roundTrip: roundTrip
                                    });
                                  } else {
                                    reject(new Error(errMessage));
                                  }
                                });
                              } else {
                                clearInterval(_this.intervalHandle);

                                var offset = _this.calculateCorrection();

                                resolve(offset);
                              }
                            }, _this.intervalTime);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function requestTime() {
        return _requestTime.apply(this, arguments);
      }

      return requestTime;
    }()
  }, {
    key: "calculateCorrection",
    value: function calculateCorrection() {
      var offsetTotal = this.timeSyncArray.reduce(function (total, _ref3) {
        var offset = _ref3.offset;
        return total + offset;
      }, 0);
      var roundTripTotal = this.timeSyncArray.reduce(function (total, _ref4) {
        var roundTrip = _ref4.roundTrip;
        return total + roundTrip;
      }, 0);
      this.timeSyncCorrection = offsetTotal / this.timeSyncArray.length;
      this.timeSyncRoundTrip = roundTripTotal / this.timeSyncArray.length;
      this.lastSyncTime = +_moment["default"].utc();
      return this.timeSyncCorrection;
    }
  }]);

  return TimeSync;
}();

exports["default"] = TimeSync;